var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "3e09ba0c-179d-46f4-b2dd-d8a492b0682f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1157ff3-45ec-4a35-be9f-e0580078f952",
    x1: -1,
    y1: 104,
    x2: 216,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3dbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "31cd5373-0e55-4dae-9d36-e40459ac6a2b",
    x1: 0,
    y1: 67,
    x2: 215,
    y2: 67,
    xlinkHref: "#d1157ff3-45ec-4a35-be9f-e0580078f952"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AllPass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 68,
    width: 215,
    height: 72,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.1,
      stroke: "url(#d1157ff3-45ec-4a35-be9f-e0580078f952)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 67,
    x2: 215,
    y2: 67,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#31cd5373-0e55-4dae-9d36-e40459ac6a2b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 215,
    height: 73,
    style: {
      fill: "#fff",
      opacity: 0.08
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPass);
export default __webpack_public_path__ + "static/media/AllPass.a0de65bd.svg";
export { ForwardRef as ReactComponent };